module.exports = __webpack_public_path__ + "assets/Deals.5607d8b0.svg";